export default {"src":"/_next/static/image/public/images/ic_no_records_without_lines.812d909f81015430c9fdce91da205ee4.svg","height":119,"width":140};